export function getFormatter(formatter) {
    return n => formatter.format(n).replace(/\u200e/gi, '');
}
//# sourceMappingURL=get-formatter.js.map